class CardProductForm extends HTMLElement {
    constructor() {
        super();
        this.scriptText = this.querySelector('script').textContent;
        this.quantity = this.querySelector('quantity-input');
        this.data = JSON.parse(this.scriptText);
        this.options = this.data.option_names;
        this.variants = this.data.variants;
        this.currentVariantInput = this.querySelector('.product-variant-id');
        this.currentVariantId = this.currentVariantInput?.value;
        this.quantity?.addEventListener('change', this.onChange.bind(this));
    }

    onChange() {
        const quantityOptios = this.options.some(option => option.toLowerCase() == 'quantity');
        
        if(!quantityOptios) return

        this.checkedVariant();
       
    }

    checkedVariant() {
        const variant = this.variants.find(variant => Number(variant.id) == Number(this.currentVariantId));
        if(!variant) return;
        const quantity = this.quantity.querySelector('input').value;
        const indexOptionQuantity = this.options.findIndex(o => o.toLowerCase() === 'quantity');
        
        const optionsNotOptionQuantity = this.getOptionsNotQuantity(variant, indexOptionQuantity);
       
        const filteredVariants = this.filterVariants(optionsNotOptionQuantity);
        const productTiers = filteredVariants.map( variant => variant[`option${indexOptionQuantity + 1}`]);
        const validTier = this.validTier(productTiers, quantity);
        
        const valideVariant = filteredVariants.find( variant => variant[`option${indexOptionQuantity + 1}`] === validTier);
        this.currentVariantInput.value = valideVariant.id;
       
    }

    filterVariants(options) {
        return this.variants.filter(variant =>
            options.every(option =>
                variant[`option${option.position}`] === option.value
            )
        );
    }

    getOptionsNotQuantity(variant, indexOptionQuantity) {
        return variant.options.reduce((acc, option, index) => {
            if( index != indexOptionQuantity) acc.push({value: option, position: index+1});
            return acc
        },[]);
    }

    validTier(tiers, quantity) {
      let str = '';
      tiers.forEach(tier => {
        const arr = tier.split('-');
        if(arr.length == 2) {
          const start = +arr[0];
          const end = +arr[1];
          if(quantity >= start && quantity <= end) {
            str = tier;
          }
        }else {
          const start = +arr[0].replace(/[\D]+/g, '');
          if(quantity >= start ) {
            str = tier;
          }
        }
      });
      return str;
    }

}

customElements.define('product-card-form', CardProductForm);